import React from "react"
import { Button, Tooltip } from "@mui/material"
import { useUsageLimit } from "src/providers/UsageLimitProvider"

interface SendButtonProps {
  /** Whether any uploaded file has validation errors */
  anyFileIncorrect: boolean
  /** Whether there are no valid files uploaded */
  noValidFiles: boolean
  /** Whether no community is selected */
  noCommunity: boolean
  /** Whether no target languages are selected */
  noTargetLanguages: boolean
  /** Whether no source language is selected */
  noSourceLanguage: boolean
  /** Whether the operation is for quoting (vs sending) */
  quoting: boolean
  /** Tooltip text to show on hover */
  sendButtonTooltip: string
  /** Function to call when the button is clicked */
  onSend: () => void
}

export const SendButton: React.FC<SendButtonProps> = ({
  anyFileIncorrect,
  noValidFiles,
  noCommunity,
  noTargetLanguages,
  noSourceLanguage,
  quoting,
  sendButtonTooltip,
  onSend
}) => {
  const { isTranslateAccessRestricted } = useUsageLimit()
  
  const isDisabled = 
    anyFileIncorrect || 
    noValidFiles || 
    noCommunity || 
    noTargetLanguages || 
    noSourceLanguage || 
    isTranslateAccessRestricted()

  const tooltipText = isTranslateAccessRestricted() ? "Monthly character limit reached." : sendButtonTooltip

  return (
    <Tooltip title={tooltipText} arrow>
      <span style={{ flex: 1, borderRadius: "inherit" }}>
        <Button
          data-testid="send-button"
          disabled={isDisabled}
          onClick={onSend}
          variant="contained"
          fullWidth
          color="secondary"
          sx={{
            py: 1.5,
            borderRadius: "inherit"
          }}
        >
          {quoting ? "Quote" : "Translate"}
        </Button>
      </span>
    </Tooltip>
  )
}

export default SendButton
